import {PermissionRowAbstract} from "./AbstractRow";
import {NO_COMMENT} from "../../../constants/Language";
import {IComboboxV2Options} from "../../combobox/v2";
import {createServiceListPromise} from "../../combobox/v2-sources";
import {ISystem} from "../../../index";
import {lm} from "../../../appContext";
import {getSearchParamsFn} from "../../../util/request";
import {MAX_RESULTS_PER_PAGE} from "../../../constants";
import {nsTooltip} from "../../../util/nsTooltip";
import mutableHtml from './mutable.html?raw';

export let template = mutableHtml;

export class viewModel extends PermissionRowAbstract {
    private NO_COMMENT = NO_COMMENT

    private getComboboxSystemRoleParams(): IComboboxV2Options<ISystem> {
        const listSource = createServiceListPromise<ISystem>({
            name: 'searchsystem',
            params: getSearchParamsFn('searchsystem')({
                orgnr: this.sp.org.org.organizationid,
                resultsprpage: MAX_RESULTS_PER_PAGE,
            }),
        })
        return {
            inputAttrs: {placeholder: lm.t('choose collection|td') ?? ''},
            initialMatch: o => o.id == this.sp.system()?.id,
            option: {
                label: o => o.name,
                tooltip: o => o ? lm.t(nsTooltip.getTitle_system(o) ?? '') ?? '' : '',
                constrain: o => !o.definitionreadonly,
            },
            onSelect: o => {
                if (o != this.sp.system()) {
                    this.sp.role(null)
                }
                this.sp.system(o ?? null)
            },
            promise: listSource.promise,
            onDispose: listSource.onDispose,
            title: o => o ? lm.t(nsTooltip.getTitle_system(o) ?? '') ?? '' : '',
            inputStatus: (selected, text) => !!selected && !!text ? 'ok' : 'warning',
        }
    }

}
